/** Tworzy ISODateString z stringa. Rzuca jeśli format niepoprawny. */
export function isoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        throw new Error(`Invalid ISO date: "${value}", expected YYYY-MM-DD`);
    }
    return value;
}
/** Dzisiejsza data jako ISODateString */
export function today() {
    return new Date().toISOString().split('T')[0];
}
//# sourceMappingURL=date.js.map